/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47860Req {
  
  /** 项目id */
  projectNo?: string;
  /** 用户编号列表 ,String */
  userNoList?: any[];
};



export type API47860Res = {};


// 47860 删除项目成员

export interface IUsePostAPI47860Return {
  /** 删除项目成员: 接口请求状态 */
  isAPI47860Loading: boolean;
  /** 删除项目成员: 接口请求返回数据 */
  dataAPI47860: API47860Res;
  /**  删除项目成员: 接口数据请求方法 */
  fetchAPI47860Data:  (inputs: API47860Req, config?: YWRequestConfig) => Promise<API47860Res>;
  /** 删除项目成员: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47860 = ():IUsePostAPI47860Return => {
  let isMount = true;
  const [isAPI47860Loading, setIsAPI47860Loading] = useState(false);
  const [dataAPI47860, setDataAPI47860] = useState<API47860Res>({} as API47860Res);
  const requestUrl = `${basePath}/corp-admin/project/team/member/del`;

  const fetchAPI47860Data = async (inputs: API47860Req, config?: YWRequestConfig): Promise<API47860Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47860Req>) || {}) as API47860Req;
    
  
    if ( isMount ) {
      setIsAPI47860Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47860Res>(`${basePath}/corp-admin/project/team/member/del`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47860(res || {} as API47860Res);
        setIsAPI47860Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47860Loading(false);
      }
      return false as unknown as API47860Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47860Loading,
    dataAPI47860,
    fetchAPI47860Data,
    requestUrl,
  }
}

